import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookiesService {

  constructor() { }

  get(name: string) {
    const valueExists = this.checkACookieExists(name);

    if (
      valueExists
    ) {
      const cookieValue = document.cookie
        .split("; ")
        .find((row) => row.startsWith(`${name}=`))
        ?.split("=")[1];

        return cookieValue;
    } else {
      return null;
    }
  }

  set(name: string, value: string, expiryTimeInSeconds: number = 3600) {
    const currentTimeInSeconds = new Date().getTime()/1000;
    const formattedExpiryTime = new Date(((currentTimeInSeconds) + expiryTimeInSeconds) * 1000).toUTCString();
    // const cookie = `${name}=${value}; max-age=${expiryTimeInSeconds}; domain=${window.location.host}; path=/;`;
    const cookie = `${name}=${value}; max-age=${4000};  path=/`;
    document.cookie = cookie;
  }

  remove(name: string) {
    const valueExists = this.checkACookieExists(name);


    if (
      valueExists
    ) {
      this.set(name, '', -1000000);
    }
  }

  checkACookieExists(name: string) {
    return document.cookie.split(";").some((item) => item.trim().startsWith(`${name}=`));
  }

  deleteAllCookies() {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        // this.set(name, '')
        document.cookie = name + "=;Expires=Thu, 01 Jan 1970 00:00:00 GMT";

    // console.log(document.cookie)
    }
    // console.log(document.cookie)
    sessionStorage.clear();
}

setToSessionStorage(name: string, value: string) {
  sessionStorage.setItem(name, value)
}
}
